import {
  ProgressOverviewPageConfig,
  VersionReportVersionPageRowEntity,
} from '../../../../../domain/entity/version-report/VersionReportVersionEntity'
import { MasterSchedule } from '../master-schedule'
import { useProjectPrivateContext } from '../../../../context/projectContext'
import { StoredVersionReportPageDisplayState } from '../../hooks/pageDisplayState'

type ProgressOverviewProps = {
  editable: boolean
  snapshotUuid: string
  config: ProgressOverviewPageConfig
  rows: VersionReportVersionPageRowEntity[]
  updateRow: (
    rowUuid: string,
    lockVersion: number,
    key: 'status' | 'comment',
    value: string
  ) => Promise<boolean>
  takenAt?: Date
  displayState: StoredVersionReportPageDisplayState
  updateDisplayState: (
    updated: Partial<StoredVersionReportPageDisplayState>
  ) => void
  displayStateRestoreToken?: number
}
export const ProgressOverview = ({
  editable,
  snapshotUuid,
  config,
  rows,
  updateRow,
  takenAt,
  displayState,
  updateDisplayState,
  displayStateRestoreToken,
}: ProgressOverviewProps) => {
  const { projectUuid } = useProjectPrivateContext()
  return (
    <MasterSchedule
      editable={editable}
      projectUuid={projectUuid}
      targetUuids={config.tableRows}
      pageRows={rows}
      updateRow={updateRow}
      rootUuid=""
      snapshotUuid={snapshotUuid}
      baseDate={takenAt}
      displayState={displayState}
      updateDisplayState={updateDisplayState}
      displayStateRestoreToken={displayStateRestoreToken}
    />
  )
}
